module.exports = __webpack_public_path__ + "img/icon_fn_nfc.272af95f.svg";